import api from './api';

// Error Knowledge Base.
//   list()  — read entries for a sync template (main API, any authenticated user) to show KB on error lines.
//   adminList / create / update / remove — superadmin CRUD on the admin API.
const errorKbService = {
  // Main API — scoped to a sync template (always pass one from the reconciliation page).
  list: async (syncTemplateId) => {
    const qs = syncTemplateId ? `?syncTemplateId=${encodeURIComponent(syncTemplateId)}` : '';
    const response = await api.get(`/errorkb${qs}`);
    return response.data;
  },

  // Admin API — all templates (management page), or one when filtered.
  adminList: async (syncTemplateId) => {
    const qs = syncTemplateId ? `?syncTemplateId=${encodeURIComponent(syncTemplateId)}` : '';
    const response = await api.get(`/admin/errorkb${qs}`);
    return response.data;
  },

  get: async (id) => (await api.get(`/admin/errorkb/${id}`)).data,

  create: async (data) => (await api.post('/admin/errorkb', data)).data,

  update: async (id, data) => (await api.put(`/admin/errorkb/${id}`, data)).data,

  remove: async (id) => (await api.delete(`/admin/errorkb/${id}`)).data,
};

export default errorKbService;
